import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, inject } from 'intact-vue-next';
import template from './item.vdt';
import { FORM, RECORD_KEY } from './form';
import { useRecordItem } from '../../hooks/useRecordComponent';
import { useError } from './useError';
import { useValidate } from './useValidate';
import { useDirty } from './useDirty';
import { useConfigContext } from '../config';
var MessageOrClassname;
(function (MessageOrClassname) {
  MessageOrClassname[MessageOrClassname["Message"] = 0] = "Message";
  MessageOrClassname[MessageOrClassname["ClassName"] = 1] = "ClassName";
})(MessageOrClassname || (MessageOrClassname = {}));
var typeDefs = {
  value: null,
  rules: Object,
  messages: Object,
  classNames: Object,
  errorClassName: String,
  label: String,
  htmlFor: String,
  hideLabel: Boolean,
  fluid: Boolean,
  validateOnStart: Boolean
};
export var FormItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FormItem, _Component);
  function FormItem() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.form = inject(FORM, null);
    _this.error = useError();
    _this.dirty = useDirty(function () {
      return _this.validateHook.validate;
    });
    _this.validateHook = useValidate(_this.error.getErrorMessage, _this.error.getErrorClassName, _this.error.message, _this.dirty.isDirty);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = FormItem.prototype;
  _proto.init = function init() {
    useRecordItem(RECORD_KEY);
  };
  _proto.validate = function validate() {
    if (!this.form) return true;
    return this.validateHook.validate();
  };
  _proto.isValid = function isValid() {
    return this.validateHook.isValid.value;
  };
  _proto.reset = function reset() {
    this.error.reset();
    this.validateHook.reset();
    this.dirty.reset();
  };
  return FormItem;
}(Component);
FormItem.template = template;
FormItem.typeDefs = typeDefs;